import Vue from "vue"
import Router from "vue-router"
Vue.use(Router)


const routers = {
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "codeLab",
      component: () => import(`./index.vue`),
      children: [
        {
          path: '/task',
          name: 'task',
          component: () => import(`@/code-lab/component/mission/mission-list.vue`)
        },
        {
          path: '/exchange',
          name: 'exchange',
          component: () => import(`@/code-lab/component/exchange/exchange.vue`)
        },
        {
          path: '/guide',
          name: 'guide',
          component: () => import(`@/code-lab/component/login-guide/login-guide.vue`)
        },
      ]
    },
    {
      path: "*",
      redirect: '/'
    }
  ]
};
if (process.env.VUE_APP_mode === "dev") {
  routers.routes.push({
      path: "/developer/icons",
      name: "IconDashboard",
      component: () => import("./icon-dashboard/icon-dashboard.vue")
  });
}
export default new Router(routers)